import { render, staticRenderFns } from "./lkuArinvdeffered.vue?vue&type=template&id=19f4ecb7"
import script from "./lkuArinvdeffered.vue?vue&type=script&lang=js"
export * from "./lkuArinvdeffered.vue?vue&type=script&lang=js"
import style0 from "./lkuArinvdeffered.vue?vue&type=style&index=0&id=19f4ecb7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports